import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/gantt/gantt.module.css";

export default {
  "ganttVerticalContainer": "gantt-module__ganttVerticalContainer_Dvluva__100",
  "horizontalContainer": "gantt-module__horizontalContainer_Dvluva__100",
  "wrapper": "gantt-module__wrapper_Dvluva__100"
};
      